import React from 'react';

const Confirmed = () => (
  <svg
    width="24"
    height="28"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.8676 3.99487L9.60759 0.649873L9.49509 0.604874C9.17025 0.522334 8.82993 0.522334 8.50509 0.604874L8.39259 0.649873L1.13259 3.99487C0.78967 4.15276 0.502399 4.41048 0.308364 4.73432C0.114329 5.05816 0.0225676 5.43303 0.0450881 5.80987L0.300088 10.0699C0.444794 12.5201 1.2831 14.8786 2.71726 16.8705C4.15141 18.8624 6.1223 20.4055 8.40009 21.3199C8.59098 21.4058 8.79825 21.4493 9.00759 21.4474C9.20658 21.4504 9.40379 21.4095 9.58509 21.3274C11.8657 20.4153 13.8397 18.8731 15.2766 16.8811C16.7136 14.889 17.5541 12.5293 17.7001 10.0774L17.9551 5.81737C17.9792 5.43929 17.8881 5.06278 17.694 4.73745C17.4999 4.41212 17.2118 4.15322 16.8676 3.99487ZM12.9376 9.24487L8.93259 13.7449C8.86743 13.8194 8.78816 13.8804 8.69934 13.9241C8.61052 13.9679 8.51391 13.9936 8.41509 13.9999H8.37759C8.18913 14.0013 8.00705 13.9316 7.86759 13.8049L5.11509 11.2699C4.96889 11.1346 4.88241 10.9468 4.87467 10.7478C4.86693 10.5488 4.93858 10.3548 5.07384 10.2086C5.2091 10.0624 5.3969 9.97594 5.59592 9.96821C5.79494 9.96047 5.98889 10.0321 6.13509 10.1674L8.32509 12.1849L11.8126 8.25487C11.9465 8.1155 12.129 8.03318 12.322 8.02507C12.5151 8.01697 12.7039 8.08371 12.849 8.21138C12.994 8.33905 13.0842 8.51779 13.1007 8.71033C13.1173 8.90288 13.0588 9.09437 12.9376 9.24487Z"
      fill="#007A3D"
    />
  </svg>
);

export default Confirmed;
